import getMeta from '@atlassian/jira-get-meta';
import { fg } from '@atlassian/jira-feature-gating';
import { SET_CURRENT_USER, type SetCurrentUserAction } from '../../../actions/user/index.tsx';
import type { CurrentUserEntityState } from './types.tsx';

type Action = SetCurrentUserAction;

const defaultState = (): CurrentUserEntityState => {
	if (!fg('backlog-assignee-filter-sort-fix')) {
		return null;
	}

	const id = getMeta('ajs-atlassian-account-id');
	if (!id) return null;
	return {
		id,
		avatarUrl: '',
		displayName: '',
	};
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: CurrentUserEntityState = defaultState(),
	action: Action,
): CurrentUserEntityState => {
	switch (action.type) {
		case SET_CURRENT_USER:
			return action.payload;
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
